import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { InputValueTable } from '../Form/components/InputValueTable';

// Helpers
import { hydrateManifestSection } from '../Form/helpers/hydrateManifestSection';

// Manifest
import { manifest as questionManifest } from '../../manifests/questionManifest';

// Types
import { SummationLineItem, ROW_TYPES } from '../../types';

interface CustomFinancialsTableReadOnlyProps {
    data?: Record<string, any>;
    componentKey: string;
    totalHighlight?: boolean;
}

export const FinancialsTableReadOnly: React.FC<CustomFinancialsTableReadOnlyProps> = ({
    data,
    componentKey,
    totalHighlight
}) => {
    const questionConfig = questionManifest[componentKey];
    const { subManifest } = questionConfig;
    const { t } = useTranslation('questions');
    const manifest = React.useMemo(() => hydrateManifestSection(subManifest), [subManifest, hydrateManifestSection]);
    const tableData = React.useMemo(() => {
        return (manifest ?? []).map((fieldConfig) => {
            return {
                value: data?.[fieldConfig?.key],
                required: fieldConfig?.componentProps?.required ?? false,
                displayAsNegative: fieldConfig?.componentProps?.displayAsNegative ?? false,
                key: fieldConfig?.key,
                id: fieldConfig?.id,
                label: fieldConfig?.componentProps?.labelKey
                    ? t(fieldConfig?.componentProps?.labelKey)
                    : 'Label Undefined',
                type: ROW_TYPES.READ_ONLY,
                hidden: fieldConfig?.componentProps?.hidden,
                fieldConfig
            };
        }) as SummationLineItem[];
    }, [manifest, data]);

    return (
        <InputValueTable
            label={''}
            data={tableData}
            noHeader
            rightAlignSecondCol
            totalHighlight={totalHighlight}
            background={totalHighlight ? '#eff8fe' : '#fafcff'}
        />
    );
};
